"use strict";

angular
    .module("internal.inspections")
    .controller("InternalInspectionsChecklist", [
        "$scope",
        "$rootScope",
        "$stateParams",
        "IPTemplates",
        "$state",
        "$uibModal",
        "$q",
        "FBForms",
        function(
            $scope,
            $rootScope,
            $stateParams,
            IPTemplates,
            $state,
            $uibModal,
            $q,
            FBForms
        ) {
            $scope.masterChecklist = $stateParams.checklist;
            $scope.checklist = $stateParams.checklist;
            $scope.checklistID = $stateParams.id;
            $scope.checklistLoading = true;
            $scope.deleting = false;
            $scope.copying = false;
            $scope.publishing = false;
            $scope.archiving = false;
            $scope.unarchiving = false;
            $scope.pdfGenerated = false;
            $scope.documentInfo = {};

            $scope.setMasterChecklist = function(checklist) {
                checklist.result_set.sort(function(a, b) {
                    if (a.fail === b.fail) {
                        if (a.abbr < b.abbr) {
                            return -1;
                        } else if (a.abbr > b.abbr) {
                            return 1;
                        } else {
                            return 0;
                        }
                    } else if (a.fail < b.fail) {
                        return -1;
                    } else if (a.fail > b.fail) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                $scope.masterChecklist = checklist;
                $scope.checklist = angular.copy($scope.masterChecklist);
                if ($scope.checklistID) {
                    IPTemplates.getDocumentData($scope.checklistID).then(function (document) {
                        if (document && document.document_code != null && document.document_code != null) {
                            $scope.documentInfo.id = document.document_id;
                            $scope.documentInfo.code = document.document_code;
                            $scope.pdfGenerated = true;
                        }
                    });
                }
            };

            $scope.resetChecklist = function() {
                if ($scope.masterChecklist == null) {
                    $scope.masterChecklist = {};
                }
                $scope.checklist = angular.copy($scope.masterChecklist);
            };

            $scope.delete = function() {
                $uibModal
                    .open({
                        animation: true,
                        templateUrl: "templates/confirm/confirm.html",
                        controller: "ConfirmModalController",
                        resolve: {
                            message: function() {
                                return "Are you sure you want to delete this checklist?";
                            }
                        }
                    })
                    .result.then(function(result) {
                        if (result) {
                            $scope.deleting = true;
                            IPTemplates.delete($scope.checklistID).then(
                                function() {
                                    $state.go(
                                        "internal.inspecting.resource.checklists"
                                    );
                                    $scope.deleting = false;
                                }
                            );
                        }
                    });
            };

            $scope.publish = function() {
                $scope.publishing = true;
                $scope.masterChecklist.published = true;
                IPTemplates.save($scope.masterChecklist).then(function(
                    checklist
                ) {
                    $scope.publishing = false;
                    $scope.setMasterChecklist(checklist);
                });
            };

            $scope.archive = function() {
                $scope.archiving = true;
                $scope.masterChecklist.archive = true;
                IPTemplates.save($scope.masterChecklist).then(function(
                    checklist
                ) {
                    $scope.archiving = false;
                    $scope.setMasterChecklist(checklist);
                });
            };

            $scope.unarchive = function() {
                $scope.unarchiving = true;
                $scope.masterChecklist.archive = false;
                IPTemplates.save($scope.masterChecklist).then(function(
                    checklist
                ) {
                    $scope.unarchiving = false;
                    $scope.setMasterChecklist(checklist);
                });
            };

            $scope.copy = function(copyForm) {
                $scope.copying = true;
                var copiedChecklist = angular.copy($scope.masterChecklist);
                copiedChecklist.id = undefined;
                copiedChecklist.name = "Copy of " + $scope.masterChecklist.name;
                copiedChecklist.published = false;
                copiedChecklist.archive = false;

                var promises = [];
                promises.push(IPTemplates.save(copiedChecklist));
                if (copyForm == null && copiedChecklist.form_id != null) {
                    promises.push(FBForms.getByID(copiedChecklist.form_id));
                }

                $q.all(promises).then(function(arr) {
                    var checklist = arr[0];
                    var form =
                        arr.length > 1
                            ? arr[1]
                            : copyForm == null
                            ? null
                            : angular.copy(copyForm);

                    if (checklist != null) {
                        if (form != null) {
                            form.id = undefined;
                            form.name = "Copy of " + form.name;
                            FBForms.save({
                                form: form,
                                template_id: checklist.id
                            }).then(function() {
                                $state.go(
                                    "internal.inspecting.resource.checklist.layout",
                                    { id: checklist.id, checklist: checklist }
                                );
                                $scope.copying = false;
                            });
                        } else {
                            $state.go(
                                "internal.inspecting.resource.checklist.layout",
                                { id: checklist.id, checklist: checklist }
                            );
                            $scope.copying = false;
                        }
                    } else {
                        $scope.copying = false;
                    }
                }).catch(function (response) {
                    // handle error
                });
            };

            $scope.getTemplate = function() {
                $scope.checklistLoading = true;

                IPTemplates.getByID($stateParams.id).then(function(checklist) {
                    $scope.setMasterChecklist(checklist);
                    $scope.checklistLoading = false;
                });
            };

            $scope.viewPdf = function () {
                window.open($rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument&documentID=' + $scope.documentInfo.id.toUpperCase() + '&code=' + $scope.documentInfo.code);
            };

            if ($stateParams.id != null) {
                $scope.getTemplate();
            } else {
                var checklist = {};
                checklist.result_set = [
                    {
                        id: guid(),
                        name: "Complaint",
                        abbr: "C",
                        fail: 0,
                        initval: true,
                        show_comments: false
                    },
                    {
                        id: guid(),
                        name: "Non-Compliant",
                        abbr: "NC",
                        fail: 1,
                        initval: false,
                        show_comments: true
                    },
                    {
                        id: guid(),
                        name: "Not Applicable",
                        abbr: "N/A",
                        fail: 2,
                        initval: false,
                        show_comments: false
                    }
                ];
                checklist.reinspection = 0;
                checklist.fee = 0;
                checklist.auto_fail = 1;
                $scope.setMasterChecklist(checklist);
                $scope.checklistLoading = false;
            }
        }
    ]);
